/**
 * 이벤트 관련 API
 * OpenAPI Generator로 생성된 타입을 사용하며, 기존 Axios 인스턴스와 통합
 */
export class CommunityEventService {
    constructor(axiosInstance) {
        Object.defineProperty(this, "axios", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.axios = axiosInstance;
    }
    /**
     * 이벤트를 slice 형태로 조회합니다. status가 null이면 전체 이벤트를 조회합니다.
     * @param pageable - pageable
     * @param status - status
     * @returns 이벤트를 slice 형태로 조회합니다. status가 null이면 전체 이벤트를 조회합니다. 결과
     */
    getEventsByStatus(pageable, status) {
        return this.axios.get(`/co/v1/support/events`, {
            params: {
                ...pageable,
                status: status,
            },
        });
    }
    /**
     * 이벤트 상세조회
     * @param eventId - eventId
     * @returns 이벤트 상세조회 결과
     */
    getEventDetail(eventId) {
        return this.axios.get(`/co/v1/support/events/${eventId}/detail`);
    }
    /**
     * 진행중인 이벤트의 모바일 롤링 배너 조회
     * @param pageable - pageable
     * @returns 진행중인 이벤트의 모바일 롤링 배너 조회 결과
     */
    getInProgressEventsRollingBanners(pageable) {
        return this.axios.get(`/co/v1/support/events/rolling-banners`, {
            params: {
                ...pageable,
            },
        });
    }
}
//# sourceMappingURL=event.service.js.map